var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPicture = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0061 22.6705C28.0061 25.6173 25.6173 28.0061 22.6705 28.0061H9.33165C6.3849 28.0061 3.99609 25.6173 3.99609 22.6705V9.33165C3.99609 6.3849 6.3849 3.99609 9.33165 3.99609H22.6705C25.6173 3.99609 28.0061 6.3849 28.0061 9.33165V22.6705Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 17.3336L5.72369 15.606C6.32681 15.0029 7.14482 14.6641 7.99776 14.6641C8.85069 14.6641 9.6687 15.0029 10.2718 15.606L16.0011 21.3353",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 28.007L17.733 19.6099C18.9889 18.354 21.0252 18.354 22.2811 19.6099L27.5355 24.8643",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPicture, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/picture.04f39ece.svg";
export { ForwardRef as ReactComponent };